export default {
  mask: "+7 (###) ###-##-##",
  maskChecker: /^\+7 \(\d\d\d\) \d\d\d-\d\d-\d\d$/,
  symbolsToRemove: /[()\s-]/g,
  placeholder: "+7 (999) 999-99-99",
}